export enum NotificationType {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

export class Notification {
  constructor(private readonly type: NotificationType, private readonly message: string) {}

  getType() {
    return this.type;
  }

  getMessage() {
    return this.message;
  }
}

export class ErrorNotification extends Notification {
  constructor(message: string) {
    super(NotificationType.ERROR, message);
  }
}

export class InfoNotification extends Notification {
  constructor(message: string) {
    super(NotificationType.INFO, message);
  }
}

export class WarningNotification extends Notification {
  constructor(message: string) {
    super(NotificationType.WARNING, message);
  }
}

export class SuccessNotification extends Notification {
  constructor(message: string) {
    super(NotificationType.SUCCESS, message);
  }
}
